import { V1_API_BASE_URL } from "@/configs/common"
import axios, {
  type Axios,
  type AxiosRequestConfig,
  type AxiosError,
  type AxiosResponse,
  type AxiosPromise,
} from "axios"

export interface MyAxiosInstance extends Axios {
  (config: AxiosRequestConfig): AxiosPromise
  (url: string, config?: AxiosRequestConfig): AxiosPromise
}

const unauthorizedRequest = axios.create({
  baseURL: V1_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH",
  },
})

unauthorizedRequest.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data
  },
  (error: AxiosError) => {
    throw error.response?.data
  }
)

export default unauthorizedRequest
